module.exports = "<div class=\"charts-container\" [ngStyle]=\"{'width': width}\">\r\n    <ng-content></ng-content>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/charts/charts.component.html
// module id = ./src/app/components/charts/charts.component.html
// module chunks = main